import script from "./DownloadRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownloadRecord.vue?vue&type=script&lang=ts&setup=true"

import "./DownloadRecord.vue?vue&type=style&index=0&id=edec15bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edec15bc"]])

export default __exports__